import Layout from '@/views/layout/Layout'
const imgSearchRouter = {
    path: '/imgSearch',
    name: 'imgSearch',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 图搜搜路由
        {
            path: '/imgSearchIndex',
            name: 'imgSearchIndex',
            meta: { name: '图搜搜'},
            component: () => import('@/views/imgSearch/index'),
        },
        // 图搜搜列表页路由
        {
            path: '/imgSearchList',
            name: 'imgSearchList',
            meta: { name: '图搜搜列表'},
            component: () => import('@/views/imgSearch/list'),
        },
    ]
}
export default imgSearchRouter


// WEBPACK FOOTER //
// ./src/router/modules/imgSearch.js